import { ref } from "vue";
import ConnectionManagerWorker from "@editor/items/relation/relation_distribution/ConnectionManager.worker.ts?worker";
import QuadCurve from "./relation_distribution/QuadCurve";
import Line from "./relation_distribution/Line";

import type { SceneTreeItemSize } from "../scene/SceneTreeItem";
import type { Uid } from "@/helpers/utility/Id";

const pathWorker = new ConnectionManagerWorker();

const optimizedPathLines = ref<{ [connectionUid: string]: (QuadCurve | Line)[] }>(
  {}
);

type ConnectionItem = {
  startUid: Uid<"sceneNode" | "flow">;
  endUid: Uid<"sceneNode" | "flow">;
};

let _relationsWithoutNones: { [id: number]: ConnectionItem } = {};
let _sceneNodeSizes: { [uid: string]: SceneTreeItemSize } = {};
let _round = true;
let _space = true;
let _deoverlap = true;

let refreshWaiting = false;
let working = false;

pathWorker.onmessage = ({ data }) => {
  optimizedPathLines.value = data.optimizedPathLines;

  working = false;

  if (refreshWaiting) {
    refreshWaiting = false;
    updatePathlines(_relationsWithoutNones, _sceneNodeSizes, {
      round: _round,
      space: _space,
      deoverlap: _deoverlap
    });
  }
};

pathWorker.onerror = (error) => {
  console.warn("error", error);
};

function updatePathlines(
  relationsWithoutNones: { [id: string]: ConnectionItem },
  sceneNodeSizes: { [uid: string]: SceneTreeItemSize },
  { round = true, space = true, deoverlap = true } = {}
) {
  if (working) {
    refreshWaiting = true;
    _relationsWithoutNones = relationsWithoutNones;
    _sceneNodeSizes = sceneNodeSizes;
    _round = round;
    _space = space;
    _deoverlap = deoverlap;
  } else {
    working = true;

    pathWorker.postMessage(
      // use JSON parse/stringify to deep clone
      // This is much faster than lodash cloneDeep
      JSON.stringify({
        relationsWithoutNones,
        sceneNodeSizes,
        round,
        space,
        deoverlap
      })
    );
  }
}

export default function usePathsUpdater() {
  return {
    optimizedPathLines,
    updatePathlines
  };
}
